import { twMerge } from 'tailwind-merge';

/** DataTableLoadingBar is a component that displays a loading state for data tables.
 * It visually indicates that data is being loaded.
 * */
export const DataTableLoadingBar = ({
  className,
  isLoading = true
}: {
  /** adds on to default styles by adding a class */
  className?: string;
  /** hides the loading bar if false */
  isLoading?: boolean;
}) => {
  return (
    <div
      className={twMerge(
        'w-full h-1 bg-gray-200 overflow-hidden',
        !isLoading && 'opacity-0',
        className
      )}
      aria-label="Loading bar"
    >
      <div
        className={twMerge(
          'h-full w-full bg-heaven-light animate-loading',
          !isLoading && 'opacity-0'
        )}
      />
    </div>
  );
};
